import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Users from './pages/Users';
import PrivateRoute from './components/PrivateRoute';
import Background from './components/Background';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import Login from './pages/Login';
import { UserProvider } from './UserContext';
import CreateUser from './pages/CreateUser';
import UpdateUser from './pages/UpdateUser';
import Appearance from './pages/Appearance';
import Instructors from './pages/Instructors';
import CreateInstructor from './pages/CreateInstructor';
import UpdateInstructor from './pages/UpdateInstructor';
import Modules from './pages/Modules';
import CreateModule from './pages/CreateModule';
import UpdateModule from './pages/UpdateModule';
import News from './pages/News';
import CreateNews from './pages/CreateNews';
import UpdateNews from './pages/UpdateNews';
import ServiceUnavailable from './pages/ServiceUnavailable';
import NotFound from './pages/NotFound';

import Configs from './pages/Configs';

function RoutesApp() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/service-unavailable' element={ <ServiceUnavailable /> } />

                <Route element={
                    <UserProvider>
                        <PrivateRoute />
                    </UserProvider>
                }>
                    <Route element={<Background />}>
                        <Route path='/' element={ <Users /> } />
                        <Route path='/users' element={ <Users /> } />
                        <Route path='/users/create' element={ <CreateUser /> } />
                        <Route path='/users/update/:id' element={ <UpdateUser /> } />
                        <Route path='/instructors' element={ <Instructors /> } />
                        <Route path='/instructors/create' element={ <CreateInstructor /> } />
                        <Route path='/instructors/update/:id' element={ <UpdateInstructor /> } />
                        <Route path='/modules' element={ <Modules /> } />
                        <Route path='/modules/create' element={ <CreateModule /> } />
                        <Route path='/modules/update/:id' element={ <UpdateModule /> } />
                        <Route path='/news' element={ <News /> } />
                        <Route path='/news/create' element={ <CreateNews /> } />
                        <Route path='/news/update/:id' element={ <UpdateNews /> } />
                        <Route path='/appearance' element={ <Appearance /> } />
                        <Route path='/configs' element={ <Configs /> } />
                    </Route>
                </Route>


                <Route element={<AuthenticatedRoute />}>
                    <Route path='/login' element={ <Login /> } />
                </Route>

                <Route path='*' element={ <NotFound /> } />
            </Routes>
        </BrowserRouter>
    );
}

export default RoutesApp;